module.exports = __webpack_public_path__ + "static/media/rin-logo.083502a9.png";